import { ChildFieldType, FieldType, Id, Timestamp } from 'ev-types';

export enum SystemMappedPatientField {
  FirstName = 'system_mapped_patient_first_name',
  MiddleName = 'system_mapped_patient_middle_name',
  LastName = 'system_mapped_patient_last_name',
  Suffix = 'system_mapped_patient_suffix',
  Email = 'system_mapped_patient_email',
  MobilePhone = 'system_mapped_patient_mobile_phone',
  PhoneCell = 'system_mapped_patient_phone_cell',
  Dob = 'system_mapped_patient_dob',
  Gender = 'system_mapped_patient_gender',
  Sex = 'system_mapped_patient_sex',
  PreferredLanguage = 'system_mapped_patient_preferred_language',
  Address1 = 'system_mapped_patient_address_1',
  Address2 = 'system_mapped_patient_address_2',
  City = 'system_mapped_patient_city',
  State = 'system_mapped_patient_state',
  Zip = 'system_mapped_patient_zip',
}

export const QueueManagementFieldLabels = [
  'IR Facility',
  'IR Requester',
  'IR Requested Interpreter Language',
  'IR Requested Modality',
  'IR Visit Type Name',
  'IR Tile Name',
  'IR Requester ID',
];

export type EDataDefinitionChildrenAttributes = {
  id?: Id;
  field_type: ChildFieldType;
  is_required?: boolean;
  sort?: number;
  dataset?: string;
  _destroy?: boolean;
};

export type EDataDefinitionTextAttributes = {
  id?: Id;
  lang: string;
  text: string;
  _destroy?: boolean;
};

export type EDataDefinitionAttributes = {
  id: Id;
  name: string;
  label: string;
  is_sensitive: boolean;
  data_type: string;
  field_type: FieldType;
  description: string | null;
  system_mapping: string | null;
  hint: string | null;
  created_at: Timestamp;
  updated_at: Timestamp;
  dataset?: string[] | string | null;
  category_ids: string[];
  created_by_user_id: string | null;
  created_by_user_name: string | null;
  used_count: number;
  children?: EDataDefinitionChildrenAttributes[];
  definition_texts?: EDataDefinitionTextAttributes[];
  non_translatable?: boolean;
};
